import { render, staticRenderFns } from "./HotelCount.vue?vue&type=template&id=380cd85f&scoped=true"
import script from "./HotelCount.vue?vue&type=script&lang=js"
export * from "./HotelCount.vue?vue&type=script&lang=js"
import style0 from "./HotelCount.vue?vue&type=style&index=0&id=380cd85f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380cd85f",
  null
  
)

export default component.exports